import convert from "convert-units";

export const unitConvert = ({ val = 0, from = "ml", to = "ml" }) => {
  const res = convert(val).from(from).to(to);
  return res ?? 0;
};
